import { ENVIRONMENT } from '@updater-core/lib/environment';

export function transformEntityBrandings({
  entityBrandings = [],
  whiteLabel: _whiteLabel,
}) {
  const cloudinaryEndpoint = ENVIRONMENT.endpoints.cloudinary;

  function isCompanyOrDivision(entity) {
    return entity.type === 'COMPANY' || entity.type === 'DIVISION';
  }

  function isProfessional(entity) {
    return ['PROFESSIONAL', 'COBRANDED_AGENT'].includes(entity.type);
  }

  function professionalDescription(entity) {
    return entity.teamName || entity.title;
  }

  function cloudinarySrc({ baseUrl, format, filename, filetype = 'jpg' }) {
    return `${baseUrl}/${format}/${filename}.${filetype}`;
  }

  function sortByKind(a, b) {
    return a.kind < b.kind ? -1 : a.kind > b.kind ? 1 : 0;
  }

  const entities = entityBrandings.filter((entity) => entity.showBranding);

  const companies = entities
    .filter((entity) => isCompanyOrDivision(entity) && entity.kind !== 'us')
    .map((company) => ({
      ...company,
      formattedUrl: cloudinarySrc({
        baseUrl: cloudinaryEndpoint,
        format: 'q_auto:good,c_pad,h_50',
        filename: company.logoId,
      }),
    }));

  const professionals = entities
    .filter((entity) => isProfessional(entity))
    .sort(sortByKind)
    .map((professional) => ({
      ...professional,
      description: professionalDescription(professional),
      formattedUrl: cloudinarySrc({
        baseUrl: cloudinaryEndpoint,
        format: 'c_fill,w_50,h_50',
        filename: professional.logoId,
      }),
    }));

  const updater = {
    className: `${companies.length > 0 ? 'app-logo' : ''} company-logo`,
    displayName: 'Updater',
    logoUrl: cloudinarySrc({
      baseUrl: cloudinaryEndpoint,
      format: 'q_auto:good,c_pad,h_50',
      filename: 'updater_logo',
    }),
  };

  const whiteLabel = _whiteLabel
    ? {
        // eslint-disable-next-line @getify/proper-ternary/nested
        className: `${companies.length > 0 ? 'app-logo' : ''} company-logo`,
        displayName: _whiteLabel.displayName || _whiteLabel.name,
        logoUrl: cloudinarySrc({
          baseUrl: cloudinaryEndpoint,
          format: 'q_auto:good,c_pad,h_50',
          filename: _whiteLabel.logoId,
        }),
        favicon: cloudinarySrc({
          baseUrl: _whiteLabel.favicon?.baseUrl,
          format: 'q_auto:good,c_pad,h_32',
          filename: _whiteLabel.favicon?.id,
          filetype: 'ico',
        }),
      }
    : undefined;

  return {
    companies,
    professionals,
    updater,
    whiteLabel,
  };
}
